module.exports = __webpack_public_path__ + "static/img/b-icon-1-active.add8a68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/b-icon-1-active.png
// module id = 25qi
// module chunks = 0